<template>
	<div class="contianer main-content">

		<div class="row">
			
			<div class="col-12 header-container text-center pb-3">
				<div class="checkmark" alt="Checkmark"></div>
			</div>

			<div class="col-12 header-container text-center pb-2">
				<h2 class="lrg primary-highlight">Thank you for your payment.</h2>
			</div>

			<div class="col-12 text-center">
				<img src="./../assets/img/shadow_bottom.png" alt="shadow">
			</div>
		</div>

		<div class="row">
			<div class="col-12 pt-4 text-center">
				<img :src="gcImage" :alt="$gstate.getPaymentMethodName(this.$gstate.getPaymentMethod()) + ' eGift Card'">
			</div>
		</div>

		<div class="row">
			<div class="col-12 pt-4 text-center">
				<h4 class="dark-highlight"><strong>${{ pq.fiatAmount | num2decimal }} <small>{{ pq.fiatCurrency }}</small> {{ $gstate.getPaymentMethodName(this.$gstate.getPaymentMethod()) }} eGift Card</strong></h4>
			</div>
		</div>		

		<div class="row panel-warning mt-4 mb-5 p-3">
			<div class="col-12 col-sm-1 text-center">
				<div class="exclamation" alt="Exclamation"></div>
			</div>
			<div class="col-12 col-sm-11 text-center text-warning">
				Upon receipt of your payment, your gift card will be sent to <strong>{{ bi.emailAddress }}</strong>.
			</div>
		</div>

		<div class="row mt-4">
			<div class="col-12 text-center">
				<a href="#" id="payment-flexepin-success-next" class="btn next-btn" v-on:click.prevent="done">Done</a>
			</div>
		</div>
	</div>
</template>

<script>

import { eventBus } from './../main'

export default {
    data() {
        return {
			pq: this.$gstate.getFlowState(),
			bi: this.$gstate.getBuyerInfo(),
            address: this.$gstate.getCryptoAddress(),
        }
	},
	mounted() {
		this.$emit('setLeaveNotification', false);
		eventBus.$emit('logGTMTransactionEvent', "transactionComplete");
	},
	created(){
        this.$emit('setRateHoldTimer', false);
    },
    methods: {
        done: function (){
            this.$emit('reset', false);
			this.$gstate.redirectSuccess();
        }
	},
	computed: {
		gcImage: function(){
			return '/static/img/sell/' + this.$gstate.getPaymentMethod() + '.png';
		}
	},
}
</script>